import React, { useRef } from 'react';
import './styles.sass';

interface OTPInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  length?: number;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  className?: string;
  inputMode?: 'numeric' | 'text';
}

export const OTPInput: React.FC<OTPInputProps> = ({
  value,
  onChange,
  onComplete,
  length = 6,
  placeholder = '000000',
  autoFocus = false,
  disabled = false,
  className = '',
  inputMode = 'numeric'
}) => {
  const isPastingRef = useRef(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Ignorar onChange durante paste para evitar validação prematura
    if (isPastingRef.current) {
      return;
    }
    
    // Aceitar apenas números e limitar ao tamanho especificado
    const numericValue = e.target.value.replace(/\D/g, '').slice(0, length);
    onChange(numericValue);
    
    // Auto-submit quando código completo
    if (numericValue.length === length && onComplete) {
      setTimeout(() => onComplete(numericValue), 100);
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    isPastingRef.current = true;
    
    // Pegar o texto colado
    const pastedText = e.clipboardData.getData('text');
    // Limpar e extrair apenas números
    const numericValue = pastedText.replace(/\D/g, '').slice(0, length);
    
    // Atualizar o código
    onChange(numericValue);
    
    // Resetar flag após um pequeno delay
    setTimeout(() => {
      isPastingRef.current = false;
      
      // Auto-submit quando código completo
      if (numericValue.length === length && onComplete) {
        onComplete(numericValue);
      }
    }, 50);
  };

  return (
    <div className={`otp-input-container ${className}`}>
      <input
        name='otp_code'
        type='text'
        value={value}
        onChange={handleChange}
        onPaste={handlePaste}
        placeholder={placeholder}
        maxLength={length}
        inputMode={inputMode}
        className='otp-code-input'
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </div>
  );
};
